import { render, staticRenderFns } from "./ProductTemplatePropagation.vue?vue&type=template&id=050dece9&scoped=true&"
import script from "./ProductTemplatePropagation.vue?vue&type=script&lang=js&"
export * from "./ProductTemplatePropagation.vue?vue&type=script&lang=js&"
import style0 from "./ProductTemplatePropagation.vue?vue&type=style&index=0&id=050dece9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "050dece9",
  null
  
)

export default component.exports